/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { EntityDefinitions } from "../InternalInterfaces";
import { extractDisplayNames, isMaxUrlLengthReached, removeCommaFromEnd } from "../MetadataEntityCRMUtils";
var MetadataEntityAttributeService = /** @class */ (function () {
    function MetadataEntityAttributeService(commonDataService, perfService) {
        this.commonDataService = commonDataService;
        this.perfService = perfService;
        this.UrlLengthWithoutEntities = 250;
    }
    MetadataEntityAttributeService.prototype.getAllEntitiesWithAttributes = function (entitiesToInclude, languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, retValue, filters, promises, responses, responses_1, responses_1_1, response;
            var e_1, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!entitiesToInclude || entitiesToInclude.length === 0) {
                            throw new Error("At least one entity has to be included in the search.");
                        }
                        perfEvent = this.perfService.startScenario("Client-MetadataStore-getAllEntities-Perf-Ms");
                        retValue = [];
                        filters = this.buildEntityFilters(entitiesToInclude);
                        promises = filters.map(function (filter) { return _this.commonDataService.getRecords(EntityDefinitions, filter); });
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        responses = _b.sent();
                        try {
                            for (responses_1 = __values(responses), responses_1_1 = responses_1.next(); !responses_1_1.done; responses_1_1 = responses_1.next()) {
                                response = responses_1_1.value;
                                retValue.push.apply(retValue, __spreadArray([], __read(this.extractCRMEntityMetadataWithAttributes(response, languageCode)), false));
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (responses_1_1 && !responses_1_1.done && (_a = responses_1.return)) _a.call(responses_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        perfEvent.complete();
                        return [2 /*return*/, retValue];
                }
            });
        });
    };
    MetadataEntityAttributeService.prototype.getEntitiesWithAttribute = function (attributeLogicalName, languageCode) {
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, query, entityMetadataCRM, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        perfEvent = this.perfService.startScenario("Client-MetadataStore-getEntitiesWithAttribute-Perf-Ms");
                        query = "$select=LogicalName,DisplayName&$expand=Attributes($select=LogicalName,DisplayName;$filter=LogicalName eq '".concat(attributeLogicalName, "')");
                        return [4 /*yield*/, this.commonDataService.getRecords(EntityDefinitions, query)];
                    case 1:
                        entityMetadataCRM = _a.sent();
                        result = this.extractCRMEntityMetadata(entityMetadataCRM, languageCode);
                        perfEvent.complete();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    MetadataEntityAttributeService.prototype.buildEntityFilters = function (entitiesToInclude) {
        var _this = this;
        var retValue = [];
        var entityLogicalNames = "";
        entitiesToInclude.forEach(function (entityName) {
            if (isMaxUrlLengthReached(entityLogicalNames.length, entityName.length, _this.UrlLengthWithoutEntities)) {
                retValue.push(_this.createFilter(removeCommaFromEnd(entityLogicalNames)));
                entityLogicalNames = "'".concat(entityName, "',");
            }
            else {
                entityLogicalNames += "'".concat(entityName, "',");
            }
        });
        retValue.push(this.createFilter(removeCommaFromEnd(entityLogicalNames)));
        return retValue;
    };
    MetadataEntityAttributeService.prototype.createFilter = function (entityLogicalNames) {
        return "$select=LogicalName,DisplayName&$filter=Microsoft.Dynamics.CRM.In(PropertyName='LogicalName',PropertyValues=[".concat(entityLogicalNames, "])&$expand=Attributes($select=LogicalName,DisplayName)");
    };
    MetadataEntityAttributeService.prototype.extractCRMEntityMetadataWithAttributes = function (entityMetadataCRM, languageCode) {
        var _this = this;
        var retValue = entityMetadataCRM
            .filter(function (x) { var _a; return ((_a = x === null || x === void 0 ? void 0 : x.Attributes) === null || _a === void 0 ? void 0 : _a.length) !== 0; })
            .map(function (x) {
            return {
                logicalName: x.LogicalName,
                displayName: extractDisplayNames(x.DisplayName, languageCode, x.LogicalName),
                attributes: _this.extractAttributes(x.Attributes, languageCode)
            };
        });
        return retValue;
    };
    MetadataEntityAttributeService.prototype.extractAttributes = function (attributesCRM, languageCode) {
        var retValue = attributesCRM.map(function (x) {
            return {
                logicalName: x.LogicalName,
                displayName: extractDisplayNames(x.DisplayName, languageCode, x.LogicalName)
            };
        });
        return retValue;
    };
    MetadataEntityAttributeService.prototype.extractCRMEntityMetadata = function (entityMetadataCRM, languageCode) {
        var retValue = entityMetadataCRM
            .filter(function (x) { var _a; return ((_a = x === null || x === void 0 ? void 0 : x.Attributes) === null || _a === void 0 ? void 0 : _a.length) !== 0; })
            .map(function (x) {
            return {
                logicalName: x.LogicalName,
                displayName: extractDisplayNames(x.DisplayName, languageCode, x.LogicalName)
            };
        });
        return retValue;
    };
    return MetadataEntityAttributeService;
}());
export { MetadataEntityAttributeService };
